import SButton from '../SButton.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'SCreateButton',
	components: {
		SButton
	}
});
